import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useTrackEvent from '@/hooks/useTrackEvent';
import { AuthLayout } from '@/layouts';
import { VStack } from '@/components/core';
import { Loader2 } from 'lucide-react';

const STORAGE_KEYS = {
  result: 'paymentResult',
  type: 'paymentType',
  returnTo: 'paymentReturnTo',
} as const;

export default function BillingResultSuccess() {
  const { t } = useTranslation('billing');
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const track = useTrackEvent();

  React.useEffect(() => {
    // Mark success so the global handler shows a modal
    sessionStorage.setItem(STORAGE_KEYS.result, 'success');
    const type = params.get('type') || '';
    if (type) sessionStorage.setItem(STORAGE_KEYS.type, type);

    try {
      void track('payment_success', 'conversion', {
        type: type || undefined,
        source: 'redirect',
      });
    } catch {}

    const returnTo = sessionStorage.getItem(STORAGE_KEYS.returnTo);
    if (returnTo) {
      sessionStorage.removeItem(STORAGE_KEYS.returnTo);
      navigate(returnTo, { replace: true });
    } else {
      navigate('/shop', { replace: true });
    }
  }, [navigate, params]);

  return (
    <AuthLayout
      showBranding={false}
      maxWidth="sm"
      className="design-page-gradient"
    >
      <VStack gap="md" align="center" aria-busy="true" aria-live="polite">
        <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
        <p className="design-text-secondary">{t('payment.processing')}</p>
      </VStack>
    </AuthLayout>
  );
}


